import {
  ProposalCardStatusEnum,
  ProposalCardTypeEnum
} from "@repo/core/enums/proposals";

export const proposalsMock = [
  {
    date: "Sexta-feira, 22/07/2024",
    items: [
      {
        cardName: "Cartão Fidelidade Lojas Ferreira",
        proposalId: "9999999",
        status: ProposalCardStatusEnum.ANALYSIS_CREDIT_DESK,
        statusCode: "04",
        type: ProposalCardTypeEnum.FID,
        name: "Maria Luiza dos Santos Ribeiro e Silva"
      },
      {
        cardName: "Cartão Lojas Ferreira",
        proposalId: "9999999",
        status: ProposalCardStatusEnum.ANALYSIS_CREDIT_DESK,
        statusCode: "04",
        type: ProposalCardTypeEnum.FID,
        name: "João da Silva Neves Figueiredo"
      },
      {
        cardName: "Cartão Lojas Ferreira",
        proposalId: "9999999",
        status: ProposalCardStatusEnum.ANALYSIS_CREDIT_DESK,
        statusCode: "04",
        type: ProposalCardTypeEnum.FID,
        name: "Maria Luiza dos Santos Ribeiro e Silva"
      },
      {
        cardName: "Cartão Lojas Ferreira",
        proposalId: "9999999",
        status: ProposalCardStatusEnum.ANALYSIS_CREDIT_DESK,
        statusCode: "04",
        type: ProposalCardTypeEnum.FID,
        name: "Maria Luiza dos Santos Ribeiro e Silva"
      }
    ]
  }
];
